import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

export default function ReviewedFilter({
  value = ['reviewed', 'unreviewed'],
  onChange,
}) {
  const hasReviewed = value.includes('reviewed');
  const hasUnreviewed = value.includes('unreviewed');

  return (
    <ToggleButtonGroup
      value={value}
      onChange={(e, newValue) => {
        // If user unselects both, treat as "show all"
        if (!newValue || newValue.length === 0) {
          onChange(['reviewed', 'unreviewed']);
        } else {
          onChange(newValue);
        }
      }}
      size="small"
    >
      <Tooltip title="Reviewed">
        <ToggleButton value="reviewed" style={{ padding: '2px 4px', minWidth: 0 }}>
          <CheckCircleIcon
            fontSize="small"
            color={hasReviewed ? 'primary' : 'inherit'}
          />
        </ToggleButton>
      </Tooltip>

      <Tooltip title="Unreviewed">
        <ToggleButton value="unreviewed" style={{ padding: '2px 4px', minWidth: 0 }}>
          <RadioButtonUncheckedIcon
            fontSize="small"
            color={hasUnreviewed ? 'primary' : 'inherit'}
          />
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
}
